<section [class.open]="display" class="fixed z-10 inset-0 overflow-y-auto" (click)=" componentName !== 'BannersModalComponent' && close()">
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:p-0 bg-gray-900 bg-opacity-40">
        <div (click)="$event.stopPropagation()" class="align-bottom bg-white text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full contents" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div class="card w-full md:w-auto bg-white mx-4 px-4 pt-5 pb-4 sm:p-6 sm:pb-4 rounded-lg mb-5">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</section>